import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { THEMES } from 'root-constants'
import { PageIdWoofzS1612 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_S1612: Record<
  Exclude<PageIdWoofzS1612, PageIdWoofzS1612.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofzS1612.DOG_BREED_S1_6_12]: {
    progressBar: 'controlled',
    hasHeader: true,
    headerId: HeaderId.TITLE_MENU,
    id: PageId.DOG_BREED_S1_6_12,
  },
  [PageIdWoofzS1612.DOG_AGE_S1_6_12]: {
    progressBar: 'controlled',
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    id: PageId.DOG_AGE_S1_6_12,
  },
  [PageIdWoofzS1612.SHELTER_S1_6_12]: {
    progressBar: 'controlled',
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    id: PageId.SHELTER_S1_6_12,
  },
  [PageIdWoofzS1612.COMMANDS_S1_6_12]: {
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
    id: PageId.COMMANDS_S1_6_12,
  },
  [PageIdWoofzS1612.SUBSCRIPTIONS_S1_6_12]: {
    hasHeader: false,
    id: PageId.SUBSCRIPTIONS_S1_6_12,
  },
  [PageIdWoofzS1612.CHAT_UPSELL_S1_6_12]: {
    hasHeader: true,
    theme: THEMES.POLICY,
    id: PageId.CHAT_UPSELL_S1_6_12,
  },
  [PageIdWoofzS1612.UPSELL_1_S1_6_12]: {
    hasHeader: true,
    theme: THEMES.POLICY,
    id: PageId.UPSELL_1_S1_6_12,
  },
  [PageIdWoofzS1612.DOWNLOAD_S1_6_12]: {
    hasHeader: true,
    theme: THEMES.POLICY,
    id: PageId.DOWNLOAD_S1_6_12,
  },
}
